import { useMutation } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";
import { createNotification } from "../../../shared/store/notifications";

export const registerAttendance = async (data) => {
  const res = await axios.apiCadernoVirtual.post(
    "/meeting-service/meeting/registerPresence",
    {
      studentId: _cookies.getItem("auth").user.alunoid,
      objectId: data.eventId,
      objectType: data.eventType,
      token: _cookies.getItem("auth").token,
    }
  );
  return res;
};

export const useRegisterAttendance = ({ config } = {}) => {
  return useMutation({
    ...config,
    mutationFn: registerAttendance,
    onSuccess: () => {
      createNotification({
        type: "success",
        message: "Presença registrada com sucesso",
      });
    },
  });
};
